import React from "react";
import { Autocomplete, Box, InputLabel, OutlinedInput, TextField } from "@mui/material";
import FormSection from "../../Forms/FormSection/form-section";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { DbUserGroupInfos } from "../../../Core/Api/Types/db-user-group-infos";
import { ObjectClass } from "../../../Core/Api/Types/object-class";
import { ObjectLayer } from "../../../Core/Api/Types/object-layer";
import { DbUserGroupRoleInfos } from "../../../Core/Api/Types/db-user-group-role-infos";
import { useTranslation } from "react-i18next";

interface ConfigFilteringProps {
  groupInfos: DbUserGroupInfos | DbUserGroupRoleInfos;
  onSetGroupInfos?: (
    value: any,
    context: "allowedAssetsClasses" | "filterTitleBusinessUnits" | "filterAssets" | "filterContents"
  ) => void;
  onModalQBOpen?: (layer: ObjectLayer) => void;
}

const ConfigFiltering: React.FC<ConfigFilteringProps> = (props) => {
  const { t } = useTranslation();
  const { groupInfos, onSetGroupInfos, onModalQBOpen } = props;

  return (
    <FormSection title={t("common:filtering")} status="todo" sx={{ mb: 2 }}>
      <InputLabel sx={{ mb: 1 }}>{t("field:label.allowedAssetsClasses")}</InputLabel>
      <Autocomplete
        multiple
        options={Object.keys(ObjectClass)}
        popupIcon={<ExpandMoreRoundedIcon />}
        value={groupInfos.allowedObjectClasses || []}
        getOptionLabel={(option: any) => option}
        renderOption={(props, option) => (
          <Box component="li" sx={{ "& > img": { mr: 2, flexShrink: 0 } }} {...props}>
            {option}
          </Box>
        )}
        renderInput={(params) => (
          <OutlinedInput {...params.InputProps} inputProps={params.inputProps} required sx={{ width: "100%" }} />
        )}
        sx={{ width: "100%", mb: 2 }}
        id={"allowedAssetsClasses"}
        onChange={(e, value) => {
          onSetGroupInfos && onSetGroupInfos(value, "allowedAssetsClasses");
        }}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.allowedBusinessUnits")}</InputLabel>
      <Autocomplete
        value={groupInfos.filterTitleBusinessUnits || []}
        multiple
        onChange={(e, value) => {
          onSetGroupInfos && onSetGroupInfos(value, "filterTitleBusinessUnits");
        }}
        options={[]}
        freeSolo
        sx={{ width: "100%", mb: 2 }}
        id={"filterTitleBusinessUnits"}
        renderInput={(params) => <TextField sx={{ mt: "-24px" }} {...params} />}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.filterAssets")}</InputLabel>
      <OutlinedInput
        value={groupInfos.customFilters?.find((x) => x.layer === ObjectLayer.Asset)?.query}
        id={"filterAssets"}
        sx={{ width: "100%", mb: 2 }}
        onClick={() => onModalQBOpen && onModalQBOpen(ObjectLayer.Asset)}
        onChange={(e) => onSetGroupInfos && onSetGroupInfos(e, "filterAssets")}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.filterContents")}</InputLabel>
      <OutlinedInput
        value={groupInfos.customFilters?.find((x) => x.layer === ObjectLayer.Content)?.query}
        id={"filterContents"}
        sx={{ width: "100%" }}
        onClick={() => onModalQBOpen && onModalQBOpen(ObjectLayer.Content)}
        onChange={(e) => onSetGroupInfos && onSetGroupInfos(e, "filterContents")}
      />
    </FormSection>
  );
};

export default ConfigFiltering;
